import { createContext, useContext } from "react";

interface MobileNavigationContextValue {
  openMenu: () => void;
  /** False on full-screen task flows where the bottom tab bar is hidden. */
  hasTabBar: boolean;
}

export const MobileNavigationContext = createContext<MobileNavigationContextValue>({
  openMenu: () => {},
  hasTabBar: false,
});

export const useMobileNavigation = () => useContext(MobileNavigationContext);
